// @ts-nocheck
import React, { useState } from "react";
import {
    Alert,
    IconButton,
    InputAdornment,
    List,
    ListItem,
    ListItemText,
    TextField,
    Typography,
    Zoom,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

// api-difusiones reconoce los remitentes sin respuesta por este prefijo y los exceptúa de la
// verificación contra los alias de LDAP, donde estas direcciones no existen. Por eso el prefijo
// es fijo y no editable: se antepone a lo que escribe el operador.
export const PREFIJO_NO_REPLY = "no-reply";

const DOMINIO_INSTITUCIONAL = "frba.utn.edu.ar";

const dominioDe = (direccion) => direccion.split("@")[1]?.toLowerCase() ?? "";

const esDireccionValida = (direccion) => /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(direccion);

/**
 * Lista de direcciones de remitente sin respuesta del área. Mantiene el estado del campo de
 * carga; las direcciones confirmadas las administra el formulario que lo incluye.
 */
export default function CamposNoReply({ direcciones = [], onChange, className }) {
    const [sufijo, setSufijo] = useState("");
    const [error, setError] = useState(null);

    const agregar = () => {
        const direccion = `${PREFIJO_NO_REPLY}${sufijo.trim()}`;

        if (sufijo.trim() === "") {
            setError("Complete la dirección antes de agregarla.");
            return;
        }
        if (!esDireccionValida(direccion)) {
            setError(`"${direccion}" no es una dirección de correo válida.`);
            return;
        }
        if (direcciones.some((d) => d.toLowerCase() === direccion.toLowerCase())) {
            setError("Esa dirección ya está en la lista.");
            return;
        }

        onChange([...direcciones, direccion]);
        setSufijo("");
        setError(null);
    };

    const quitar = (direccion) => onChange(direcciones.filter((d) => d !== direccion));

    const dominiosNoInstitucionales = [
        ...new Set(direcciones.map(dominioDe).filter((d) => d && d !== DOMINIO_INSTITUCIONAL)),
    ];

    return (
        <>
            {error && (
                <Alert severity="error" onClose={() => setError(null)} sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            <TextField
                variant="outlined"
                fullWidth
                className={className}
                label="Direcciones no-reply"
                placeholder="-secretaria@frba.utn.edu.ar"
                value={sufijo}
                onChange={({ target }) => setSufijo(target.value)}
                onKeyPress={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        agregar();
                    }
                }}
                helperText="No-replys que el área podrá usar como remitente en sus difusiones."
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Typography component="span" color="text.secondary">
                                {PREFIJO_NO_REPLY}
                            </Typography>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={agregar} size="large">
                                <AddIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />

            {dominiosNoInstitucionales.length > 0 && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                    Verifique que {dominiosNoInstitucionales.length > 1 ? "los subdominios" : "el subdominio"}{" "}
                    <strong>{dominiosNoInstitucionales.join(", ")}</strong> exista y tenga publicados sus
                    registros de correo. De lo contrario las difusiones pueden llegar a spam.
                </Alert>
            )}

            {direcciones.length > 0 && (
                <List dense>
                    {direcciones.map((direccion) => (
                        <Zoom in key={direccion}>
                            <ListItem
                                secondaryAction={
                                    <IconButton edge="end" aria-label="quitar" onClick={() => quitar(direccion)} size="large">
                                        <RemoveIcon />
                                    </IconButton>
                                }
                            >
                                <ListItemText
                                    primary={
                                        <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                                            {direccion}
                                        </div>
                                    }
                                />
                            </ListItem>
                        </Zoom>
                    ))}
                </List>
            )}
        </>
    );
}
